/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { BigCommercePalletization } from "./BigCommercePalletization";
import {
  BigCommercePalletizationFromJSON,
  BigCommercePalletizationFromJSONTyped,
  BigCommercePalletizationToJSON,
  BigCommercePalletizationToJSONTyped,
} from "./BigCommercePalletization";
import type { BigCommercePickupDefaults } from "./BigCommercePickupDefaults";
import {
  BigCommercePickupDefaultsFromJSON,
  BigCommercePickupDefaultsFromJSONTyped,
  BigCommercePickupDefaultsToJSON,
  BigCommercePickupDefaultsToJSONTyped,
} from "./BigCommercePickupDefaults";
import type { BigCommerceDeliveryDefaults } from "./BigCommerceDeliveryDefaults";
import {
  BigCommerceDeliveryDefaultsFromJSON,
  BigCommerceDeliveryDefaultsFromJSONTyped,
  BigCommerceDeliveryDefaultsToJSON,
  BigCommerceDeliveryDefaultsToJSONTyped,
} from "./BigCommerceDeliveryDefaults";
import type { BigCommerceGroupLocationTypeRule } from "./BigCommerceGroupLocationTypeRule";
import {
  BigCommerceGroupLocationTypeRuleFromJSON,
  BigCommerceGroupLocationTypeRuleFromJSONTyped,
  BigCommerceGroupLocationTypeRuleToJSON,
  BigCommerceGroupLocationTypeRuleToJSONTyped,
} from "./BigCommerceGroupLocationTypeRule";
import type { BigCommerceProductHandlingTime } from "./BigCommerceProductHandlingTime";
import {
  BigCommerceProductHandlingTimeFromJSON,
  BigCommerceProductHandlingTimeFromJSONTyped,
  BigCommerceProductHandlingTimeToJSON,
  BigCommerceProductHandlingTimeToJSONTyped,
} from "./BigCommerceProductHandlingTime";
import type { BigCommerceGroupAccessorialRule } from "./BigCommerceGroupAccessorialRule";
import {
  BigCommerceGroupAccessorialRuleFromJSON,
  BigCommerceGroupAccessorialRuleFromJSONTyped,
  BigCommerceGroupAccessorialRuleToJSON,
  BigCommerceGroupAccessorialRuleToJSONTyped,
} from "./BigCommerceGroupAccessorialRule";
import type { CheckoutRateSelector } from "./CheckoutRateSelector";
import {
  CheckoutRateSelectorFromJSON,
  CheckoutRateSelectorFromJSONTyped,
  CheckoutRateSelectorToJSON,
  CheckoutRateSelectorToJSONTyped,
} from "./CheckoutRateSelector";
import type { BigCommerceCustomerGroupRef } from "./BigCommerceCustomerGroupRef";
import {
  BigCommerceCustomerGroupRefFromJSON,
  BigCommerceCustomerGroupRefFromJSONTyped,
  BigCommerceCustomerGroupRefToJSON,
  BigCommerceCustomerGroupRefToJSONTyped,
} from "./BigCommerceCustomerGroupRef";
import type { BigCommerceProductRef } from "./BigCommerceProductRef";
import {
  BigCommerceProductRefFromJSON,
  BigCommerceProductRefFromJSONTyped,
  BigCommerceProductRefToJSON,
  BigCommerceProductRefToJSONTyped,
} from "./BigCommerceProductRef";

/**
 *
 * @export
 * @interface BigCommerceFreightSettings
 */
export interface BigCommerceFreightSettings {
  /**
   *
   * @type {boolean}
   * @memberof BigCommerceFreightSettings
   */
  ratesEnabled: boolean;
  /**
   *
   * @type {number}
   * @memberof BigCommerceFreightSettings
   */
  handlingTimeBusinessDays: number;
  /**
   *
   * @type {number}
   * @memberof BigCommerceFreightSettings
   */
  maxHandlingUnits: number;
  /**
   *
   * @type {number}
   * @memberof BigCommerceFreightSettings
   */
  maxRatesPerResponse: number;
  /**
   *
   * @type {Array<CheckoutRateSelector>}
   * @memberof BigCommerceFreightSettings
   */
  rateSelectors: Array<CheckoutRateSelector>;
  /**
   *
   * @type {BigCommerceDeliveryDefaults}
   * @memberof BigCommerceFreightSettings
   */
  deliveryDefaults: BigCommerceDeliveryDefaults;
  /**
   *
   * @type {BigCommercePickupDefaults}
   * @memberof BigCommerceFreightSettings
   */
  pickupDefaults: BigCommercePickupDefaults;
  /**
   *
   * @type {BigCommercePalletization}
   * @memberof BigCommerceFreightSettings
   */
  palletization: BigCommercePalletization;
  /**
   *
   * @type {Array<BigCommerceCustomerGroupRef>}
   * @memberof BigCommerceFreightSettings
   */
  requiredCustomerGroups: Array<BigCommerceCustomerGroupRef>;
  /**
   *
   * @type {Array<BigCommerceGroupAccessorialRule>}
   * @memberof BigCommerceFreightSettings
   */
  groupAccessorialRules: Array<BigCommerceGroupAccessorialRule>;
  /**
   *
   * @type {Array<BigCommerceGroupLocationTypeRule>}
   * @memberof BigCommerceFreightSettings
   */
  groupLocationTypeRules: Array<BigCommerceGroupLocationTypeRule>;
  /**
   *
   * @type {Array<BigCommerceProductRef>}
   * @memberof BigCommerceFreightSettings
   */
  excludedProducts: Array<BigCommerceProductRef>;
  /**
   *
   * @type {Array<BigCommerceProductHandlingTime>}
   * @memberof BigCommerceFreightSettings
   */
  productHandlingTimes: Array<BigCommerceProductHandlingTime>;
  /**
   *
   * @type {Array<string>}
   * @memberof BigCommerceFreightSettings
   */
  allowedCarriers: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof BigCommerceFreightSettings
   */
  blockedCarriers: Array<string>;
}

/**
 * Check if a given object implements the BigCommerceFreightSettings interface.
 */
export function instanceOfBigCommerceFreightSettings(
  value: object,
): value is BigCommerceFreightSettings {
  if (!("ratesEnabled" in value) || value["ratesEnabled"] === undefined)
    return false;
  if (
    !("handlingTimeBusinessDays" in value) ||
    value["handlingTimeBusinessDays"] === undefined
  )
    return false;
  if (!("maxHandlingUnits" in value) || value["maxHandlingUnits"] === undefined)
    return false;
  if (
    !("maxRatesPerResponse" in value) ||
    value["maxRatesPerResponse"] === undefined
  )
    return false;
  if (!("rateSelectors" in value) || value["rateSelectors"] === undefined)
    return false;
  if (!("deliveryDefaults" in value) || value["deliveryDefaults"] === undefined)
    return false;
  if (!("pickupDefaults" in value) || value["pickupDefaults"] === undefined)
    return false;
  if (!("palletization" in value) || value["palletization"] === undefined)
    return false;
  if (
    !("requiredCustomerGroups" in value) ||
    value["requiredCustomerGroups"] === undefined
  )
    return false;
  if (
    !("groupAccessorialRules" in value) ||
    value["groupAccessorialRules"] === undefined
  )
    return false;
  if (
    !("groupLocationTypeRules" in value) ||
    value["groupLocationTypeRules"] === undefined
  )
    return false;
  if (!("excludedProducts" in value) || value["excludedProducts"] === undefined)
    return false;
  if (
    !("productHandlingTimes" in value) ||
    value["productHandlingTimes"] === undefined
  )
    return false;
  if (!("allowedCarriers" in value) || value["allowedCarriers"] === undefined)
    return false;
  if (!("blockedCarriers" in value) || value["blockedCarriers"] === undefined)
    return false;
  return true;
}

export function BigCommerceFreightSettingsFromJSON(
  json: any,
): BigCommerceFreightSettings {
  return BigCommerceFreightSettingsFromJSONTyped(json, false);
}

export function BigCommerceFreightSettingsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BigCommerceFreightSettings {
  if (json == null) {
    return json;
  }
  return {
    ratesEnabled: json["ratesEnabled"],
    handlingTimeBusinessDays: json["handlingTimeBusinessDays"],
    maxHandlingUnits: json["maxHandlingUnits"],
    maxRatesPerResponse: json["maxRatesPerResponse"],
    rateSelectors: (json["rateSelectors"] as Array<any>).map(
      CheckoutRateSelectorFromJSON,
    ),
    deliveryDefaults: BigCommerceDeliveryDefaultsFromJSON(
      json["deliveryDefaults"],
    ),
    pickupDefaults: BigCommercePickupDefaultsFromJSON(json["pickupDefaults"]),
    palletization: BigCommercePalletizationFromJSON(json["palletization"]),
    requiredCustomerGroups: (json["requiredCustomerGroups"] as Array<any>).map(
      BigCommerceCustomerGroupRefFromJSON,
    ),
    groupAccessorialRules: (json["groupAccessorialRules"] as Array<any>).map(
      BigCommerceGroupAccessorialRuleFromJSON,
    ),
    groupLocationTypeRules: (json["groupLocationTypeRules"] as Array<any>).map(
      BigCommerceGroupLocationTypeRuleFromJSON,
    ),
    excludedProducts: (json["excludedProducts"] as Array<any>).map(
      BigCommerceProductRefFromJSON,
    ),
    productHandlingTimes: (json["productHandlingTimes"] as Array<any>).map(
      BigCommerceProductHandlingTimeFromJSON,
    ),
    allowedCarriers: json["allowedCarriers"],
    blockedCarriers: json["blockedCarriers"],
  };
}

export function BigCommerceFreightSettingsToJSON(
  json: any,
): BigCommerceFreightSettings {
  return BigCommerceFreightSettingsToJSONTyped(json, false);
}

export function BigCommerceFreightSettingsToJSONTyped(
  value?: BigCommerceFreightSettings | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    ratesEnabled: value["ratesEnabled"],
    handlingTimeBusinessDays: value["handlingTimeBusinessDays"],
    maxHandlingUnits: value["maxHandlingUnits"],
    maxRatesPerResponse: value["maxRatesPerResponse"],
    rateSelectors: (value["rateSelectors"] as Array<any>).map(
      CheckoutRateSelectorToJSON,
    ),
    deliveryDefaults: BigCommerceDeliveryDefaultsToJSON(
      value["deliveryDefaults"],
    ),
    pickupDefaults: BigCommercePickupDefaultsToJSON(value["pickupDefaults"]),
    palletization: BigCommercePalletizationToJSON(value["palletization"]),
    requiredCustomerGroups: (value["requiredCustomerGroups"] as Array<any>).map(
      BigCommerceCustomerGroupRefToJSON,
    ),
    groupAccessorialRules: (value["groupAccessorialRules"] as Array<any>).map(
      BigCommerceGroupAccessorialRuleToJSON,
    ),
    groupLocationTypeRules: (value["groupLocationTypeRules"] as Array<any>).map(
      BigCommerceGroupLocationTypeRuleToJSON,
    ),
    excludedProducts: (value["excludedProducts"] as Array<any>).map(
      BigCommerceProductRefToJSON,
    ),
    productHandlingTimes: (value["productHandlingTimes"] as Array<any>).map(
      BigCommerceProductHandlingTimeToJSON,
    ),
    allowedCarriers: value["allowedCarriers"],
    blockedCarriers: value["blockedCarriers"],
  };
}
